export default "__VITE_ASSET__BeYJC920__"